import { Component, OnInit } from '@angular/core';
import { dynamicEnvironment } from '../Common/DynamicEnvironment/DynamicEnvironment';
import { HospitalLoginComponent } from '../login/hospital-login/hospital-login.component';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-url-based-login-page',
  templateUrl: './url-based-login-page.component.html'
})
export class UrlBasedLoginPageComponent{

  // backOfficeOrLocalURL: boolean = dynamicEnvironment.websiteURL.includes("localhost") || dynamicEnvironment.websiteURL.includes("bo.nishwik") || dynamicEnvironment.websiteURL.includes("dev.nishwik");

  hospitalURL: boolean = dynamicEnvironment.websiteURL.includes("dev.hospital.nishwik") || dynamicEnvironment.websiteURL.includes("hospital.nishwik");

  schoolURL: boolean = dynamicEnvironment.websiteURL.includes("dev.edu.nishwik") || dynamicEnvironment.websiteURL.includes("edu.nishwik");

  societyURL: boolean = dynamicEnvironment.websiteURL.includes("dev.society.nishwik") || dynamicEnvironment.websiteURL.includes("society.nishwik");

  crmURL: boolean = dynamicEnvironment.websiteURL.includes("dev.crm.nishwik") || dynamicEnvironment.websiteURL.includes("crm.nishwik");
  
}
